import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Impressum() {
  return (
    <div
      data-testid="impressum-page"
      className="min-h-screen bg-yx-bg text-yx-text"
    >
      <header className="border-b border-yx-border bg-yx-bg/95 backdrop-blur-xl">
        <div className="mx-auto max-w-3xl px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link
            to="/"
            data-testid="impressum-back"
            className="inline-flex items-center gap-2 text-sm text-yx-muted hover:text-yx-primary"
          >
            <ArrowLeft size={16} /> Zurück zur Website
          </Link>
          <img
            src="/yardtf-logo-transparent.png"
            alt="YardTF"
            className="h-9 w-auto object-contain"
          />
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-5 sm:px-8 py-16 sm:py-24">
        <p className="text-xs font-semibold uppercase tracking-[0.28em] text-yx-secondary mb-4">
          Rechtliches
        </p>
        <h1 className="font-display font-bold tracking-tighter text-yx-primary text-4xl sm:text-5xl leading-[0.95]">
          Impressum
        </h1>
        <p className="mt-6 text-yx-muted leading-relaxed">
          Die Angaben werden in Kürze ergänzt.
        </p>
      </main>
    </div>
  );
}
